var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { AdminPlanAFY } from "@affinitysystemsgroup/github-packages-affinity-components/dist";
import { ModalCreatePlan, ModalDelete } from "../component";
import { PLAN_BUTTON_ACTION_OPTIONS } from "../constants/plan.options";
var NOOP = function () { return undefined; };
var ADMIN_PLAN_PROPS = {
    titleColor: "#3A56A1",
    onBack: NOOP,
    onClickButtonView: NOOP,
    onClickPlanTemplates: NOOP,
    onNext: NOOP,
};
export var PlanView = function (props) { return (_jsxs(_Fragment, { children: [_jsx(ModalCreatePlan, { openModal: props.openModal, onClose: props.onClose, options: props.options, dataForm: props.dataForm, onNext: props.onNext }), _jsx(ModalDelete, { openModal: props.openModalConfirm, setOpenModal: props.onCloseConfirm, title: props.modalTitle, onConfirmDelete: props.onConfirmDelete }), _jsx(AdminPlanAFY, __assign({}, ADMIN_PLAN_PROPS, { buttonActionOptions: PLAN_BUTTON_ACTION_OPTIONS, data: props.list, filters: props.filters, onClickAdd: props.onClickAdd, onClickButtonOptionsDropdown: props.onClickButtonOptionsDropdown }))] })); };
